// utils
import jwtDecode from "jwt-decode";
import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';
// actions
import getActionLoginUsuario from '../actions/auth/getActionLoginUsuario';
import setAuthToken from '../actions/chats/staff/setAuthToken';
import getActionClienteByClienteId from '../actions/clientes/getActionClienteByClienteId';
import { setSession } from '../utils/jwt';
import { getPostLoginRoute } from "src/utils/getPostLoginRoute";
import v1_actionBuscarConfig from "src/actions/v1/global/v1_actionBuscarConfig";
import { deleteAllCacheFiles } from "src/helpers/cache.helper";
import { clearAllSessionStorage } from "src/services/sessionStorage";
import { store } from "src/redux/store";
import { resetStaffState } from "src/redux/slices/staff";

import * as Sentry from '@sentry/react';
const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  cliente: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user, cliente } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
      cliente
    };
  },
  LOGIN: (state, action) => {
    const { user, cliente } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
      cliente
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    cliente: null
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
      cliente
    };
  },
  UPDATE_USER: (state, action) => ({
    ...state,
    user: { ...state.user, ...action.payload.user }
  })
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
  callbackLogin: () => Promise.resolve()
});

AuthProvider.propTypes = {
  children: PropTypes.node
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        console.log('initialize')
        const accessToken = window.localStorage.getItem('token');
        const clienteData = window.localStorage.getItem('cliente_data');

        if (accessToken) {
          setSession(accessToken);
          setAuthToken(accessToken)

          const user = jwtDecode(accessToken);

          if (user.exp < new Date() / 1000) {
            dispatch({
              type: 'INITIALIZE',
              payload: {
                isAuthenticated: false,
                user: null,
                cliente: null
              }
            });
          }

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user,
              cliente: JSON.parse(clienteData)
            }
          });


        } else {
          console.log('nao autenticado')
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
              cliente: null
            }
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
            cliente: null
          }
        });
      }
    };

    initialize();
  }, []);




  const login = async (email, password, checkManterLogado) => {

    try {
      clearAllSessionStorage();
      const response = await getActionLoginUsuario({ email: email, password: password });

      const { token, cliente } = response.data;
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(jwtDecode(response.data.token)));
      setAuthToken(response.data.token)
      const user = jwtDecode(response.data.token);

      localStorage.setItem('roomsWithNewMessages', JSON.stringify([]));
      localStorage.setItem('soundNotification', "true");
      localStorage.setItem('cliente_data', JSON.stringify(cliente));
      localStorage.setItem('zindi-data', `{"session":"${cliente.sessao}","token":"${cliente.token}"}`);
      localStorage.setItem('numberId', cliente.numero);
      localStorage.setItem('usuarioId', cliente.usuario);
      localStorage.setItem('multiSession', cliente.multiSession);
      localStorage.setItem('marketplaceId', cliente.marketplace_id);

      if (checkManterLogado) {
        localStorage.setItem('credenciais', JSON.stringify({ email, password, checkManterLogado }));
      } else {
        localStorage.removeItem('credenciais');
      }
      setSession(token);
      dispatch({
        type: 'LOGIN',
        payload: {
          user,
          cliente: cliente
        },
      });

      Sentry.setUser({
        id: user?.id,
        email: user.email,
        clienteId: user.clienteId
      });

      // Fire-and-forget: buscar config e limpar cache se necessário
      v1_actionBuscarConfig().then((res) => {
        const config = res.data.data;
        if (config?.config?.web?.deleteCacheFiles) {
          deleteAllCacheFiles();
        }
      }).catch(() => {});

      window.location.href = getPostLoginRoute(user, cliente);
      return response;
    } catch (error) {

      let responseError;

      dispatch({
        type: 'INITIALIZE',
        payload: {
          isAuthenticated: false,
          user: null
        }
      });
      if (!error) {
        responseError = { message: 'Erro ao fazer login', error: true, action: 'error' }
      } else if (error.response.status === 400) {
        responseError = { message: 'Usuário ou senha inválidos', error: true, action: 'user_pass_error' }
      } else if (error.response.status === 403) {
        responseError = { message: error.response.data.message, error: true, action: 'error' }
      }
      return responseError;
    }
  };

  const callbackLogin = async (token) => {
    try {
      setAuthToken(token);
      const user = jwtDecode(token);

      const response = await getActionClienteByClienteId(user.clienteId);
      const cliente = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      localStorage.setItem('roomsWithNewMessages', JSON.stringify([]));
      localStorage.setItem('soundNotification', "true");
      localStorage.setItem('cliente_data', JSON.stringify(cliente));
      localStorage.setItem('zindi-data', `{"session":"${cliente.sessao}","token":"${cliente.token}"}`);
      localStorage.setItem('numberId', cliente.numero);
      localStorage.setItem('usuarioId', cliente.usuario);
      localStorage.setItem('pod', cliente.pod);
      localStorage.setItem('multiSession', cliente.multiSession);
      localStorage.setItem('marketplaceId', cliente.marketplace_id);

      setSession(token);
      dispatch({
        type: 'LOGIN',
        payload: {
          user,
          cliente: cliente
        },
      });

      Sentry.setUser({
        id: user?.id,
        email: user.email,
        clienteId: user.clienteId
      });

      // Fire-and-forget: buscar config e limpar cache se necessário
      v1_actionBuscarConfig().then((res) => {
        const config = res.data.data;
        if (config?.config?.web?.deleteCacheFiles) {
          deleteAllCacheFiles();
        }
      }).catch(() => {});

      window.location.href = getPostLoginRoute(user, cliente);
    } catch (error) {
      console.error('Callback login error', error);
      dispatch({
        type: 'INITIALIZE',
        payload: {
          isAuthenticated: false,
          user: null,
          cliente: null
        }
      });
      throw error;
    }
  };

  const logout = async () => {
    setSession(null);
    localStorage.removeItem("user");
    localStorage.removeItem("zindi-data");
    localStorage.removeItem("cliente_data");
    localStorage.removeItem("usuarioId");
    localStorage.removeItem("token");
    localStorage.removeItem("multiSession");
    localStorage.removeItem("numberId");
    localStorage.removeItem("marketplaceId");
    localStorage.removeItem("multiSession");
    localStorage.removeItem("roomsWithNewMessages");

    clearAllSessionStorage();
    store.dispatch(resetStaffState());

    dispatch({ type: 'LOGOUT' });

    // if (Config.dev) {
    //   dispatch({ type: 'LOGOUT' });
    // } else {
    //   window.location.href = `${Config.urlBackend}/sso`;
    // }
  };

  const resetPassword = () => { };
  const updateProfile = (updatedFields) => {
    const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    const newUser = { ...currentUser, ...updatedFields };
    localStorage.setItem('user', JSON.stringify(newUser));

    dispatch({
      type: 'UPDATE_USER',
      payload: { user: updatedFields }
    });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        callbackLogin,
        resetPassword,
        updateProfile
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
